import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.login');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.auth.login/view.scss */
/* src/app/portal.auth.login/view.scss: no such file or directory */`],
})
export class PortalAuthLoginComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public form = {
        email: '',
        password: ''
    };

    public loading = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status === true) {
            location.href = '/home';
            return;
        }
        await this.service.render();
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    public async login() {
        if (this.loading) return;

        if (!this.form.email?.trim()) {
            await this.showModal('이메일을 입력해주세요');
            return;
        }

        if (!this.form.password) {
            await this.showModal('비밀번호를 입력해주세요');
            return;
        }

        this.loading = true;

        const payload: any = {
            email: this.form.email.trim(),
            password: this.form.password
        };

        try {
            const { code } = await wiz.call(
                'login',
                payload,
                { credentials: 'include' }
            );

            if (code === 200) {
                location.href = '/home';
            } else {
                await this.showModal('이메일 또는 비밀번호를 확인해주세요');
            }
        } catch (e) {
            await this.showModal('이메일 또는 비밀번호를 확인해주세요');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PortalAuthLoginComponent;